<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      template(v-if="!isPurchaseDomain")
        template(v-if="isOperator && isEditAccess")
          .form-group.col-md-3.col-2.mb-1
            b-button.w-100(@click="domainPurchase()" type="button" variant="info" size="sm")
              i.fa.fa-plus
              span.ml-1 {{ $t("ui.combine.purchase_domain") }}
          //- .form-group.col-md-3.col-2.mb-1
          //-   b-button.w-100(v-b-modal.domainApply type="button" variant="info" size="sm")
          //-     i.fa.fa-plus
          //-     span.ml-1 {{ $t("ui.combine.apply_domain") }}
          .form-group.col-md-3.col-2.mb-1(v-if="showActionButton('siteinfo') || showActionButton('provideroperator')")
            b-button.w-100(@click="redirectToSiteInfo" type="button" variant="warning" size="sm")
              i.fas.fa-cog
              span.ml-1 {{ $t("ui.combine.setup_logo") }}
          .form-group.col-md-12.col-12.mb-1
            .col-6.mx-0.px-0
              b-input-group(size="sm")
                b-input-group-text(slot="prepend")
                  span {{ $t('ui.domain_group') }}
                b-form-select.col-4(v-model="domainGroupOuter" size="sm" @change="getDomainOperatorList(true)")
                  option(value="") {{ $t('ui.all') }}
                  option(value="OPERATOR") {{ $t('ui.operator') }}
                  option(value="AFFILIATE") {{ $t('ui.affiliate') }}
                  option(value="MEMBER") {{ $t('ui.member') }}
        .form-group.col-12.mb-1
          SubmitButton(
            :loading="loading"
            icon="fa fa-sync"
            :text="$t('ui.refresh')"
            type="button"
            @click="getDomainOperatorList(true)"
            variant="primary"
            size="sm"
          )
      template(v-else)
        .form-group.col-md-3.col-2.mb-1
          b-input-group(size="sm")
            b-input-group-text(slot="prepend")
              span {{ $t('ui.domain_group') }}
            b-form-select(v-model="domainGroup" size="sm" @change="getDomainAvailableList(true)" disabled)
              option(value="") {{ $t('ui.all') }}
              option(value="MEMBER") {{ $t('ui.member') }}
              option(value="AFFILIATE") {{ $t('ui.affiliate') }}
        .form-group.col-md-3.col-2.mb-1
          b-input-group(size="sm")
            b-input-group-text(slot="prepend")
              i.fa.fa-search
            DebounceInput(autofocus type="text" v-model="domainName" :placeholder="$t('ui.domain_name')" @enter="getDomainAvailableList(true)" size="sm")
        .form-group.col-md-6.col-8.mb-1
          SubmitButton(
            :loading="loading"
            icon="fa fa-search"
            :text="$t('ui.search')"
            type="button"
            @click="getDomainAvailableList(true)"
            variant="primary"
            size="sm"
          )
  .card-body
    template(v-if="!isPurchaseDomain")
      .row
        .col-12
          .clusterize-scroll.table-responsive
            table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
              thead.thead-light
                tr
                  th.text-center(width="4%")
                    span #
                  th(width="15%" @click="sortOrder('domain_name')")
                    span(:title="$t('ui.domain_name')") {{ $t('ui.domain_name') }}
                    .float-right
                      i(:class="changeSortKey('domain_name')")
                  th(width="10%" @click="sortOrder('domain_type')")
                    span(:title="$t('ui.domain_type')") {{ $t('ui.domain_type') }}
                    .float-right
                      i(:class="changeSortKey('domain_type')")
                  th.text-center(width="10%" @click="sortOrder('domain_group')")
                    span(:title="$t('ui.domain_group')") {{ $t("ui.domain_group") }}
                    .float-right
                      i(:class="changeSortKey('domain_group')")
                  th.text-center(width="6%" @click="sortOrder('status')")
                    span(:title="$t('ui.status')") {{ $t("ui.status") }}
                    .float-right
                      i(:class="changeSortKey('status')")
                  th(width="10%")
                    span(:title="$t('ui.operator_id')") {{ $t("ui.operator_id") }}
                  th(width="12%")
                    span(:title="$t('ui.android_app_link')") {{ $t("ui.android_app_link") }}
                  th.text-right(width="10%")
                    span(:title="$t('ui.price')") {{ $t("ui.price") }}
                  th(width="13%")
                    span(:title="$t('ui.remark')") {{ $t("ui.remark") }}
                  th.text-right(width="10%" @click="sortOrder('created_date')")
                    span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                    i(:class="changeSortKey('created_date')")
              tbody.clusterize-content
                tr(v-if="domainOperatorList.length == 0")
                  td(colspan="10").text-center
                    span {{ $t('message.no_data_available') }}
                tr(v-for="(item, index) in domainOperatorList")
                  td.text-center
                    span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                  td
                    span(:title="item.domain_name") 
                      a.text-decoration-none(href="javascript:void(0)" @click="openNewTab(item)") {{ item.domain_name }}
                  td
                    span(:title="item.domain_type") {{ item.domain_type }}
                  td.text-center
                    span(:title="item.domain_group") {{ item.domain_group }}                                                
                  td.text-center
                    i(:class="{ 'fas fa-check text-success': item.status == 'ACTIVE', 'fas fa-times text-warning': item.status == 'DEACTIVATE'}")
                  td
                    span(v-if="item.operator_id" :title="item.operator_id") {{ item.operator_id }}
                  td()
                    template(v-if="item.domain_group == 'MEMBER'")
                      span(:title="item.android_sub") {{ item.android_sub }}
                      span.mr-1.float-right(v-if="item.android_sub == null || item.android_sub == ''")
                        a.fa.fa-edit.btn.btn-ssm.btn-primary(href="javascript:void(0)" @click="onEdit(item)" :title="$t('ui.edit')")
                      span.mr-1.float-right.ml-2(v-else)
                        a.fa.fa-trash.btn.btn-ssm.btn-danger(href="javascript:void(0)" @click="onDelete(item, 'android')" :title="$t('ui.delete')")
                      //- span(:title="item.android_sub") {{ item.android_sub }}
                      //- span.mr-1(v-if="item.android_sub == null || item.android_sub == ''")
                      //-   a.fa.fa-edit.btn.btn-ssm.btn-primary(href="javascript:void(0)" @click="onEdit(item)" :title="$t('ui.edit')")
                      //- span.mr-1.float-right.ml-2(v-else)
                      //-   a.fa.fa-trash.btn.btn-ssm.btn-danger(href="javascript:void(0)" @click="onDelete(item, 'android')" :title="$t('ui.delete')")
                    span(v-else) -
                  td.text-right
                    span(:title="$n(item.price, 'currency')") {{ item.price ? $n(item.price, 'currency') : "-" }}
                  td
                    span(:title="item.remark") {{ item.remark }}    
                  td.text-right
                    span(:title="item.created_by") {{ item.created_by }}
                    br
                    span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}

    template(v-else)
      .row
        .col-10.mb-1
          b-pagination.float-left(
            size="sm"
            hide-ellipsis
            :total-rows="totalRow1"
            :per-page="getPageSize"
            v-model="currentPage1"
            @input="changedPage1($event)")
        .col-2.mb-1
          b-input-group(:prepend="$t('ui.page_size')" size="sm")
            b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize1" size="sm")
        .col-12
          .clusterize-scroll.table-responsive
            table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
              thead.thead-light
                tr
                  th.text-center(width="4%")
                    span #
                  th(width="15%" v-if="!isOperator")
                    span(:ttile="$t('ui.domain_id')") {{ $t('ui.domain_id') }}
                  th(width="10%" @click="sortOrder1('domain_name')")
                    span(:title="$t('ui.domain_name')") {{ $t('ui.domain_name') }}
                    .float-right
                      i(:class="changeSortKey1('domain_name')")
                  th.text-center(width="10%" @click="sortOrder1('domain_group')")
                    span(:title="$t('ui.domain_group')") {{ $t("ui.domain_group") }}
                    .float-right
                      i(:class="changeSortKey1('domain_group')")
                  th.text-right(width="10%" @click="sortOrder1('price')")
                    span(:title="$t('ui.price')") {{ $t("ui.price") }}
                    .float-right
                      i(:class="changeSortKey1('price')")
                  th.text-right(width="10%" @click="sortOrder1('created_by')" v-if="!isOperator")
                    span(:title="$t('ui.created_by')") {{ $t("ui.created_by") }}
                    i(:class="changeSortKey1('created_by')")
                  th.text-right(width="10%" @click="sortOrder1('created_date')" v-if="!isOperator")
                    span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                    .float-right
                      i(:class="changeSortKey1('created_date')")
              tbody.clusterize-content
                tr(v-if="domainList.length == 0")
                  td(:colspan="!isOperator ? '10' : '7'").text-center
                    span {{ $t('message.no_data_available') }}
                tr(v-for="(item, index) in domainList")
                  td.text-center
                    span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                  td(v-if="!isOperator")
                    span(:title="item.domain_id") {{ item.domain_id }}
                  td
                    span(:title="item.domain_name") {{ item.domain_name }}                      
                    //- span.float-right(v-if="isEditAccess")
                    //-   a.fa.fa-shopping-cart.btn.btn-ssm.btn-icon.btn-primary(href="javascript:void(0)" @click="purchaseDomain(item)" :title="$t('ui.purchase')")
                  td.text-center
                    span(:title="item.domain_group") {{ item.domain_group }}
                  td.text-right
                    span(:title="$n(item.price, 'currency')") {{ item.price ? $n(item.price, 'currency') : "-" }}
                  td.text-right(v-if="!isOperator")
                    span(:title="item.created_by") {{ item.created_by }}
                  td.text-right(v-if="!isOperator")
                    span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}



  //- domainpurchase(ref="domainpurchase" @failed="handlePurchaseFailed" @clicked="handlePurchaseSuccess")
  //- domainapply(ref="domainapply" @failed="handleApplyFailed"  @clicked="handleApplySuccess")
  v-tour(name="tour1" :steps='steps' :callbacks="callbacks" :options="options") 
  adddomainapplink(ref="adddomainapplink" :item="editSelectedDomain" :appType="editSelectedAppType" @clicked="afterEditAppLink" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
// import domainpurchase from "@/components/domain/domainPurchase.vue";
// import domainapply from "@/components/domain/domainApply.vue";
import adddomainapplink from "@/components/domain/addDomainAppLink.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    adddomainapplink
    // domainpurchase,
    // domainapply,
  },
  props: {
    isPurchaseDomain: {
      type: Boolean,
      default: false
    },
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    currentPage: 1,
    totalRow: 0,
    sortKey: "domain_name",
    sortType: "desc",
    domainOperatorList: [],
    editSelectedPaymentMode: null,

    currentPage1: 1,
    totalRow1: 0,
    sortKey1: "domain_name",
    sortType1: "asc",
    domainGroup: "MEMBER",
    domainName: "",
    selectedDomain: "",
    domainList: [],
    options: {
      // labels: {
      //   buttonSkip: this.$t("message.button_skip"),
      //   buttonPrevious: this.$t("message.button_previous"),
      //   buttonNext: this.$t("message.button_next"),
      //   buttonStop: this.$t("message.button_continue")
      // }
    },
    callbacks: {
      // onStart: this.onStart,
      // onPreviousStep: this.onPreviousStep,
      // onNextStep: this.onNextStep,
      // onSkip: this.onSkip,
      // onFinish: this.onFinish,
      // onStop: this.onStop,
    },
    steps: [
      {
        target: '#v-step-0',  // We're using document.querySelector() under the hood
        content: `Discover <strong>Vue Tour</strong>!`,
        // params: {
        //   placement: 'bottom',
        //   onFinish: () => {
        //     // Trigger the click programmatically
        //     const button = document.getElementById('#v-step-0');
        //     if (button) button.click();
        //   },
        // },
      },
      // {
      //   target: '#v-step-1',
      //   content: 'An awesome plugin made with Vue.js!'
      // },
      // {
      //   target: '[data-v-step="2"]',
      //   content: 'Try it, you\'ll love it!<br>You can put HTML in the steps and completely customize the DOM to suit your needs.',
      //   params: {
      //     placement: 'top'
      //   }
      // }
    ],
    domainGroupOuter: "",
    editSelectedDomain: null,
    editSelectedAppType: 'ANDROID'
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_domainop");
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
  },
  mounted: function() { 
    if(this.isOperator) {
      // this.$tours['tour1'].start();
      this.$store.dispatch("user/setSelectedOperatorID", this.$store.getters.accountId);
      this.getDomainOperatorList();
    }
  },
  methods: {
    onEdit(e) {
      this.editSelectedDomain = e;
      this.editSelectedAppType = 'ANDROID'
      this.$refs.adddomainapplink.$refs.addDomainAppLink.show();
    },
    afterEditAppLink: function() {
      this.getDomainOperatorList();
      this.$helpers.showDialog(this.$t("ui.add_" + this.editSelectedAppType.toLowerCase() + "_app_link"), this.$t("message.success"), "success");
    },
    onDelete: function(item, apptype) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.delete_" + apptype + "_app_link_confirm", { name: item.domain_name }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmDomainAppLinkDelete(item, apptype);
          }
        });
    },
    confirmDomainAppLinkDelete: function(item, apptype) {
      let url = config.domainAppLinkRemoveUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        domain_id: item.domain_id,
        app_type: apptype.toUpperCase()
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                // item.status = status;
                this.getDomainOperatorList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    onStart() {
    },
    onPreviousStep(currentStep) {
      // console.log("onPreviousStep", currentStep);
    },
    onNextStep(currentStep) {
      // console.log("onNextStep", currentStep);
    },
    onSkip() {
      // this.$store.dispatch("layout/setTour1", true);
    },
    onFinish() {
      $(".step-1")[0].click();
    },
    onStop() {
      // this.$store.dispatch("layout/setTour1", true);
    },
    openNewTab(obj) {
      const url = obj.domain_name.startsWith('http') ? obj.domain_name : `https://${obj.domain_name}`;
      window.open(url, '_blank', "toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=250,width=1500,height=800");
    },
    showActionButton(action) {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.$store.getters.accountAuthority) {
          var roles = this.$store.getters.accountAuthority[0].authority_option;
          roles =  roles && roles.length > 0 ? roles.split(',') : [];
          if (roles.includes(action))
            return true;
          else
            return false;
        } else
          return false;
      } else {
        return true;
      }
    },
    domainPurchase() {
      this.getDomainAvailableList();
      this.$emit("click", true)
    },
    redirectToSiteInfo: function() {
      this.$router.push('/site/siteinfo');
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getDomainOperatorList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    getDomainOperatorList: function() {
      let url = config.domainOperatorListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        domain_group: this.domainGroupOuter,
        sort_key: this.sortKey,
        sort_type: this.sortType
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.domainOperatorList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handlePurchaseSuccess: function(domain) {
      this.getDomainAvailableList();

      this.$swal({
        title: this.$t("message.purchase_domain_success"),
        html: "<div>" + this.$t("ui.your_website") + ": </div>" +
              "<div id='text-to-copy'><a href='https://" + domain + "' target='_blank'>" + domain + "</a></div>",         
        type: "success",
        // showCancelButton: true,
        // confirmButtonText: this.$t("ui.copy"),
        cancelButtonText: this.$t("ui.ok"),
        allowOutsideClick: false
      }).then(isConfirm => {
        if (isConfirm.value) {
          // this.$helpers.selectText('text-to-copy')
          // try {
          //   var successful = document.execCommand('copy')
          //   this.$swal(this.$t("ui.success"), this.$t("ui.copy_success"), "success");
          // } catch (ex) {
          //   this.$swal(this.$t("ui.failed"), this.$t("ui.copy_failed"), "error");
          // }
        } else if (
          // Read more about handling dismissals
          isConfirm.dismiss === this.$swal.DismissReason.cancel
        ) {

        }
      });
    },
    handleApplySuccess: function() {
      this.getDomainOperatorList();
      this.$helpers.showDialog(this.$t("message.apply_domain_success"), this.$t("ui.success"), "success");
    },
    handlePurchaseFailed: function(tag, status) {
      this.getDomainOperatorList();
      // this.$helpers.showDialog(this.$t("message.apply_domain_failed"), this.$t("ui.failed"), "error");
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    },
    handleApplyFailed: function(tag, status) {
      this.getDomainOperatorList();
      // this.$helpers.showDialog(this.$t("message.apply_domain_failed"), this.$t("ui.failed"), "error");
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    },

    sortOrder1(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getDomainAvailableList(true);
    },
    changeSortKey1(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    changedPageSize1: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getDomainAvailableList(true);
    },
    changedPage1: function(pageNo) {
      this.currentPage = pageNo;
      this.getDomainAvailableList();
    },
    getDomainAvailableList: function(isSearch, evt) {
      let url = config.domainDefaultAvailableList2();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        module: this.domainGroup,
        domain_name: this.domainName,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.domainList = response.data.dt;
                this.totalRow = this.domainList.length > 0 ? this.domainList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    purchaseDomain: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.purchase_domain_confirm", { name: item.domain_name }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmPurchaseDomain(item);
          } else {
            this.getDomainAvailableList();
          }
        });
    },
    confirmPurchaseDomain(item) {
      let url = config.domainDefaultBuyUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        domain_id: item.domain_id
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.handlePurchaseSuccess(item.domain_name);
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                this.getDomainAvailableList();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    }
  }
};
</script>
  